import React from "react";
import {
    KeyboardDoubleArrowRight,
    KeyboardDoubleArrowLeft,
  } from "@mui/icons-material";

import { VisibilityContext } from "react-horizontal-scrolling-menu";


function Arrow({
    children,
    disabled,
    onClick
  }) {
    return (
      <button
        disabled={disabled}
        onClick={onClick}
        style={{
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          background: "#353542",
          right: "1%",
          border: 'none',
          opacity: disabled ? "0" : "1",
          userSelect: "none"
        }}
      >
        {children}
      </button>
    );
  }
  
export function LeftArrow() {
    const {
      isFirstItemVisible,
      scrollPrev,
      visibleItemsWithoutSeparators,
      initComplete
    } = React.useContext(VisibilityContext);
  
    const [disabled, setDisabled] = React.useState(
      !initComplete || (initComplete && isFirstItemVisible)
    );
    React.useEffect(() => {
      // NOTE: detect if whole component visible
      if (visibleItemsWithoutSeparators.length) {
        setDisabled(isFirstItemVisible);
      }
    }, [isFirstItemVisible, visibleItemsWithoutSeparators]);
  
    return (
      <Arrow disabled={disabled} onClick={() => scrollPrev()}>
        <KeyboardDoubleArrowLeft/>
      </Arrow>
    );
  }
  
  export function RightArrow() {
    const {
      isLastItemVisible,
      scrollNext,
      visibleItemsWithoutSeparators
    } = React.useContext(VisibilityContext);
  
    const [disabled, setDisabled] = React.useState(
      !visibleItemsWithoutSeparators.length && isLastItemVisible
    );
    React.useEffect(() => {
      if (visibleItemsWithoutSeparators.length) {
        setDisabled(isLastItemVisible);
      }
    }, [isLastItemVisible, visibleItemsWithoutSeparators]);
  
    return (
      <Arrow disabled={disabled} onClick={() => scrollNext()}>
        <KeyboardDoubleArrowRight/>
      </Arrow>
    );
  }